import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Card, CardHeader, CardBody, Row, Col, Button, Label, FormGroup } from 'reactstrap'
import { bindActionCreators } from 'redux';
import MediaQuery from 'react-responsive'
import { getQuotation, resetQuotation } from '../../../../store/quotation/actions'
import * as columns from './_columns'
import { formatHelper } from '../../../../common/helpers';
import { arrayIsNullOrEmpty } from '../../../../common/helpers/validation';
import { layout } from '../../../../common/constants'
import { DataTable, MainLoader } from '../../../../components'

class QuotationDetail extends Component {

    componentDidMount() {
        this.props.getQuotation(this.props.match.params.id)
    }

    componentWillUnmount() {
        this.props.resetQuotation();
    }
    renderField(label, value) {
        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label color='red'>{label}</Label>
                </Col>
                <Col xs='12' md='5'>
                    <p className="form-control-static">{value}</p>
                </Col>
            </FormGroup>

        )
    }

    renderFields() {
        const quotation = this.props.quotation
        return (
            <div>
                {this.renderField('Código Cotización:', quotation.code)}
                {this.renderField('Precio Total (S/):', formatHelper.toMoney(quotation.totalPrice))}
                {this.renderField('Descuento (%):', formatHelper.toBlankDiscount(quotation.discount))}
                {this.renderField('Precio Total Descontado (S/):', formatHelper.toMoney(quotation.totalPriceDiscounted))}
                {this.renderField('Cliente', `${quotation.Customer.name} ${quotation.Customer.lastname}`)}
                {this.renderField('Tienda', quotation.Store.name)}
            </div>
        )
    }

    renderDataTable(columns, data) {
        return (
            <DataTable
                data={data}
                keyField='id'
                columns={columns}
                loading={this.props.loading}
            />
        )
    }
    renderTable(items) {
        return (
            < Row >
                <Col >
                    <MediaQuery maxWidth={layout.XS_MAX_WIDTH} >
                        {this.renderDataTable(columns.columnsXS, items)}
                    </MediaQuery>
                    <MediaQuery minWidth={layout.SM_MIN_WIDTH} maxWidth={layout.MD_MAX_WIDTH} >
                        {this.renderDataTable(columns.columnsSM, items)}
                    </MediaQuery>
                    <MediaQuery minWidth={layout.LG_MIN_WIDTH} >
                        {this.renderDataTable(columns.columns, items)}
                    </MediaQuery>

                </Col>
            </Row>
        )
    }
    renderTables(quotation) {
        return (
            <Row>
                <Col >
                    {arrayIsNullOrEmpty(quotation.products) && (
                        <Row>
                            <Col>
                                <Label><b>PRODUCTOS</b></Label>
                                {this.renderTable(quotation.products)}
                            </Col>
                        </Row>
                    )}
                    {arrayIsNullOrEmpty(quotation.services) && (
                        <Row>
                            <Col>
                                <Label><b>SERVICIOS</b></Label>
                                {this.renderTable(quotation.services)}
                            </Col>
                        </Row>
                    )}
                    {arrayIsNullOrEmpty(quotation.offers) && (
                        <Row>
                            <Col>
                                <Label><b>OFERTAS</b></Label>
                                {this.renderTable(quotation.offers)}
                            </Col>
                        </Row>
                    )}
                </Col>
            </Row>
        )
    }
    render() {
        const { quotation, loading } = this.props
        if (loading) {
            return <MainLoader />
        }
        return (

            <div className="animated">

                <Card>
                    <CardHeader>
                        Detalle de Cotización
                    </CardHeader>
                    {quotation && (
                        <CardBody>
                            {this.renderFields()}
                            {this.renderTables(quotation)}
                            <Row>
                                <Col className='mt-3'>
                                    <Button color='secondary' onClick={() => this.props.history.push('/administration/quotations')} ><i className="fa fa-chevron-left mr-1" /> Volver</Button>
                                </Col>
                            </Row>
                        </CardBody>
                    )}

                </Card>
            </div >
        )
    }
}

function mapStateToProps(state) {
    const { quotation, error, loading } = state.quotation.quotationList

    return {
        quotation,
        error,
        loading,
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getQuotation, resetQuotation,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(QuotationDetail)



// WEBPACK FOOTER //
// ./src/scenes/Administration/Quotation/QuotationDetail/QuotationDetail.js